function numInputConfig(app) {
	app.config(['dynamicNumberStrategyProvider', 'frameContext', function (dynamicNumberStrategyProvider, frameContext) {
		var numSep = frameContext.user_profile && frameContext.user_profile.language.toLowerCase() == 'hu' ? ',' : '.';
		dynamicNumberStrategyProvider.addStrategy('price', {
			numSep: numSep,
			numInt: 13,
			numFract: 2,
			numThousand: true,
			numThousandSep: ' ',
			numNeg: false
		});
		dynamicNumberStrategyProvider.addStrategy('quantity', {
			numSep: numSep,
			numFract: 2,
			numInt: 13,
			numThousand: true,
			numThousandSep: ' ',
			numNeg: false
		});
		dynamicNumberStrategyProvider.addStrategy('vat', {
			numSep: numSep,
			numInt: 3,
			numAppend: '%',
			numNeg: false
		});
	}]);
}

export default numInputConfig;
